'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _modalState = require('./modalState');

var _modalState2 = _interopRequireDefault(_modalState);

var _provider = require('./provider');

var _provider2 = _interopRequireDefault(_provider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var configs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var modal = (0, _modalState2.default)();
  return {
    openModal: modal.openModal,
    closeModal: modal.closeModal,
    closeAllModal: modal.closeAllModal,
    connectModal: (0, _provider2.default)(modal)(configs)
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-modal-es/lib/createModal.js
// module id = 327
// module chunks = 0